import { render, staticRenderFns } from "./PaymentWidget.vue?vue&type=template&id=71daec4e&"
import script from "./PaymentWidget.vue?vue&type=script&lang=js&"
export * from "./PaymentWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports